var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FileManager',{attrs:{"isPermission":_vm.project.isPermission,"startPath":_vm.startPath,"col":"4","hide-tree":"","project":_vm.project}})
}
var staticRenderFns = []

export { render, staticRenderFns }